// extracted by mini-css-extract-plugin
module.exports = {"avatar":"AvatarItem_avatar__crdKh"};